import { useEffect, useRef } from 'react';
import { trackPageView, PageType } from '../services/pageTrackingService';

/**
 * Hook pour tracker automatiquement les vues de pages.
 * Le useRef persiste à travers les remounts simulés par React StrictMode,
 * donc hasTracked reste true et empêche le double comptage.
 * Lors d'une vraie navigation (vrai unmount/remount), une nouvelle instance
 * du composant crée un nouveau ref à false, permettant de recompter.
 */
export function usePageTracking(pageType: PageType) {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current) {
      hasTracked.current = true;
      trackPageView(pageType);
    }
  }, [pageType]);
}
